import React, { useEffect, useState } from "react";

import * as S from "./styles";
import { AddButton, FH, Input, Title } from "../../main-styles";
import WhiteBox from "../../../components/WhiteBox";
import { ROLES } from "../../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinusCircle,
  faPencil,
  faTrash,
} from "@fortawesome/pro-light-svg-icons";
import { deleteUser, getAllUsers } from "../../../api/user";
import { Spinner } from "reactstrap";
import Paginator from "../../../components/Paginator";
import { useNavigate } from "react-router";
import { useConfirm } from "../../../components/ConfirmProvider";
import toast from "react-hot-toast";

// TODO: excluir usuario
// TODO: inserir o usuario nao está salvando o gestor.

function Usuarios() {
  const navigate = useNavigate();
  const confirm = useConfirm();
  window.document.title = "Organnact - Admin - Usuários";
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10000);
  const [needle, setNeedle] = useState("");
  const [loadingMore, setLoadingMore] = useState(false);
  useEffect(() => {
    loadUsers();
  }, [page, perPage, needle]);
  async function loadUsers() {
    // setLoading(true);
    try {
      setLoadingMore(true);
      let users = await getAllUsers(page, perPage, needle);
      setUsers(users);
      setLoading(false);
      setLoadingMore(false);
    } catch (error) {}
  }
  function gotoEdit(id) {
    // Navigate to edit user page
    navigate(`/admin/usuarios/editar/${id}`);
  }
  function gotoNew() {
    // Navigate to new user page
    navigate(`/admin/usuarios/novo`);
  }
  async function _deleteUser(id) {
    if (
      await confirm({
        title: "Excluir usuário",
        message: "Tem certeza que deseja excluir este usuário?",
        confirmText: "Excluir",
        danger: true,
      })
    ) {
      // Call API to delete user
      await toast.promise(deleteUser(id), {
        loading: "Excluindo usuário...",
        success: "Usuário excluído com sucesso!",
        error: "Erro ao excluir usuário.",
      });

      // Reload users
      loadUsers();
    }
  }
  if (loading) {
    return (
      <S.Container>
        <Spinner />
      </S.Container>
    );
  }
  return (
    <S.Container>
      <FH style={{ justifyContent: "space-between" }}>
        <Title>Usuários</Title>
        <AddButton onClick={gotoNew}>Adicionar Usuário</AddButton>
      </FH>
      <WhiteBox style={{paddingBottom: 100, borderTopRightRadius: 0}}>
        <Title>Usuários</Title>
        <Input
          type="text"
          placeholder="Procurar usuário..."
          value={needle}
          onChange={(e) => setNeedle(e.target.value)}
        />
        <table className="table table-sm">
          <thead>
            <tr>
              <th scope="col">Username</th>
              <th scope="col">Nome</th>
              <th scope="col">Email</th>
              <th scope="col">Tipo</th>
              <th scope="col" style={{ textAlign: "right" }}>
                <Paginator
                  page={page}
                  perPage={perPage}
                  hasMore={users.length === perPage}
                  next={() => setPage((prev) => prev + 1)}
                  prev={() => setPage((prev) => Math.max(prev - 1, 1))}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {loadingMore ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  <Spinner size="sm" />
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr
                  key={user.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => gotoEdit(user.id)}
                >
                  <th scope="row" style={{ verticalAlign: "middle" }}>
                    {user.username}
                  </th>
                  <td style={{ verticalAlign: "middle" }}>{user.full_name}</td>
                  <td style={{ verticalAlign: "middle" }}>{user.email}</td>
                  <td style={{ verticalAlign: "middle" }}>
                    {user.roles.join(",")}
                  </td>
                  <td
                    style={{ verticalAlign: "middle", textAlign: "right" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      _deleteUser(user.id);
                    }}
                  >
                    <FontAwesomeIcon icon={faMinusCircle} color={"red"} />
                  </td>
                </tr>
              ))
            )}
            {users.length === 0 && (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  Nenhum usuário para você gerenciar.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </WhiteBox>
    </S.Container>
  );
}

export default Usuarios;
